<template>
  <div class="last">

    <!-- 填写手机号 -->
    <transition name="contact">
      <Contact
        :contactHide="contactHide"
        :zIndex="zIndex"
      />
    </transition>

    <!-- logo -->
    <Logo />

    <!-- bg -->
    <img
      :src="src"
      class="bgm"
    >
    <!-- poster -->
    <img
      :src="posterSrc"
      class="posterImg"
      v-if="dev === 'mobile'"
    >

    <!-- container -->
    <div :class="['container',{containerMedia:devM}]">
      <!-- pc -===========================   pc   ============================-->
      <div
        class="pc"
        v-if="dev === 'pc'"
      >
        <div class="con_box">
          <div class="pc_top_poster">
            <span :class="{span2:isWeiXin}"></span>

          </div>
          <img
            class="pc_top1 imgel"
            :src="require('@/assets/img/last/pc_top1.png')"
          >
          <img
            v-if="!isWeiXin"
            class="pc_top2 imgel"
            :src="require('@/assets/img/last/pc_top2.png')"
          >
        </div>

        <!-- 二维码 -->
        <div class="con_box">
          <div class="code_poster">
            <span></span>
          </div>
          <!-- <canvas
            class="code imgel"
            ref="canvas"
          ></canvas> -->
          <!-- -======================================================= -->
          <Code :codeSrc="codeSrc" />
          <!-- <img
            class="code imgel"
            :src="require('@/assets/img/last/code.png')"
          > -->
        </div>

        <div class="con_box">
          <div class="pc_link_poster">
            <span></span>
          </div>
          <img
            class="pc_link imgel"
            :src="require('@/assets/img/last/pc_link.png')"
            @click="contactShow"
          >
        </div>

        <div class="con_box">
          <div class="pc_footer_poster">
            <span></span>
          </div>
          <img
            class="pc_footer imgel"
            :src="require('@/assets/img/last/pc_footer.png')"
          >
        </div>

      </div>
      <div
        class="mobile"
        v-if="dev === 'mobile'"
      >
        <div class="con_box">
          <div class="mobile_text_poster">
            <span></span>
          </div>
          <img
            class="mobile_text imgel selectNone"
            :src="require('@/assets/img/last/m_text.png')"
          >
        </div>
        <img
          :src="require('@/assets/img/last/mobile_link.png')"
          class="mobile_link"
          @click="contactShow"
        >
      </div>
      <img
        :class="['btn',{btnMedia:devM}]"
        :src="require('@/assets/img/last/btn.png')"
        @click="handleAgain"
      >

    </div>
  </div>
</template>

<script>
import Logo from "../logo";
import Code from "./components/code";
import Contact from "./components/contact"; // 手机号
export default {
  name: "Last",
  components: {
    Logo,
    Code,
    Contact
  },
  data() {
    return {
      contact: false,
      zIndex: false
    };
  },
  computed: {
    // 结果数组
    score() {
      return this.$store.state.score;
    },
    // 是不是微信浏览器
    isWeiXin() {
      return this.$store.state.isWeiXin;
    },
    // 性别 1男  2女
    sex() {
      // 男没5
      // 女没3

      if (this.max === 5) {
        return "w";
      } else if (this.max === 3) {
        return "m";
      } else {
        return this.$store.state.sex === 1 ? "m" : "w";
      }
    },
    // // 角色  // 0碎梦  1血河  2神相  3铁衣  4九灵  5素问  6龙吟
    // 结果中最大值的下标
    max() {
      let maxNum = Math.max.apply(null, this.score);
      return this.score.indexOf(maxNum);
    },
    // 是否是手机
    dev() {
      return this.$store.state.dev ? "mobile" : "pc";
    },
    devM() {
      return this.$store.state.dev;
    },
    // 生成1-3之间的随机数包括1和3;
    random() {
      return parseInt(Math.random() * 3) + 1;
    },
    // 返回最终背景地址
    src() {
      return require(`@/assets/img/posterBg/${this.dev}/${this.max}${this.sex}${
        this.random
      }.jpg`);
    },
    // 返回最终海报地址
    posterSrc() {
      return require(`@/assets/img/poster/${this.max}${this.sex}${
        this.random
      }.jpg`);
    },
    // 返回生成二维码的地址
    codeSrc() {
      return `${
        this.$store.state.__dirname
      }poster.html?src=${require("@/assets/img/poster/" +
        this.max +
        this.sex +
        this.random +
        ".jpg")}&role=${this.max}`;
    },
    audioObj() {
      return this.$store.state.audioObj;
    }
  },
  mounted() {
    this.audioObj.play(); // 播放音频
  },
  methods: {
    handleAgain() {
      nie.config.stats.url.add(
        location.host + location.pathname + "/page4/",
        "结果页:不信，我要再测一次"
      );
      window.location.reload();
    },
    contactShow() {
      this.zIndex = true;
      nie.config.stats.url.add(
        location.host + location.pathname + "/page4/",
        "结果页:填写联系方式点击"
      );
    },
    contactHide() {
      this.zIndex = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-enter-active,
.contact-leave-active {
  transition: opacity 0.5s ease;
}
.contact-leave-to,
.contact-enter {
  opacity: 0;
}
.contact-leave,
.contact-enter-to {
  opacity: 1;
}
@import "~@/assets/styles/com.scss";
.last {
  @include wh(100%, 100%);
  @include LTput();
  overflow: hidden;
}
.container {
  @include TBcenter;
  right: 3.3rem;
  @include wh(3.05rem, 6.45rem);
  @media all and (max-width: 990px) {
    right: 2rem;
  }
}
.containerMedia {
  @include wh(4rem, 5rem);
  @include LRcenter;
  top: unset;
  bottom: 0;
  transform: translate(-50%) rotate(90deg);
}
.imgel {
  @include LTput();
}
.con_box {
  position: relative;
}
.mobile_text {
  @include wh(3.86rem);
}
.mobile_text_poster {
  @include wh(3.86rem);

  span {
    display: block;
    @include imgPoster(101.55%);
  }
}
.pc {
  @include LRcenter;
  @include wh(1.97rem);

  .con_box:nth-child(1) {
    margin-bottom: 0.2rem;
  }
  .con_box:nth-child(2) {
    margin-bottom: 0.25rem;
  }
  .con_box:nth-child(3) {
    margin-bottom: 0.1rem;
  }
}
.pc_top1 {
  @include wh(1.97rem);
}
.pc_top2 {
  @include wh(1.97rem);
  top: 0.37rem;
}
.pc_top_poster {
  @include wh(1.97rem);

  span {
    display: block;
    @include imgPoster(37%);
  }
  span.span2 {
    display: block;
    @include imgPoster(18.78%);
  }
}
.pc_link {
  @include wh(4.47rem);
  @include LRcenter;
  animation: contactP 0.6s ease-in-out infinite alternate;
}
.pc_link_poster {
  @include wh(4.47rem);
  span {
    display: block;
    @include imgPoster(15.43%);
  }
}

.pc_footer {
  @include wh(2.56rem);
  @include LRcenter;
}
.pc_footer_poster {
  @include wh(2.56rem);
  span {
    display: block;
    @include imgPoster(14.84%);
  }
}

.code {
  @include LTput;
  @include wh(1.97rem);
  left: inherit;
  right: 0;
}
.code_poster {
  @include wh(1.97rem);
  span {
    display: block;
    @include imgPoster(100%);
  }
}
.mobile {
  position: relative;
}
.mobile_link {
  @include LRcenter;
  @include wh(3.3rem);
  bottom: 0.65rem;
  animation: contactM 0.6s ease-in-out infinite alternate;
}

.btn {
  @include wh(4rem);
  @include LRcenter;
  bottom: 0;
  transform: translateX(-55%);
}
.btnMedia {
  z-index: 10;
}
.selectNone {
  @include selectNone;
}
.bgm {
  @include selectNone;
  @include bgObject;
}
.posterImg {
  @include LTput;
  @include wh(auto, 100%);
  opacity: 0;
}

@keyframes contactP {
  0% {
    transform: translate(-50%, -5%);
  }
  100% {
    transform: translate(-50%, 5%);
  }
}
@keyframes contactM {
  0% {
    transform: translate(-45%, -5%);
  }
  100% {
    transform: translate(-45%, 5%);
  }
}
</style>


